import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, FormGroup, Label, Input } from 'reactstrap';
import { useSelector } from 'react-redux';

const ModalCrearMenuPermission = ({ isOpen, toggle, onSave }) => {
    const [formData, setFormData] = useState({
        menu_id: '',
        role: '',
    });
    const tenantId = useSelector((state) => state.Context.tenantId);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSave = () => {
        const dataToSend = { ...formData, tenantId };
        onSave(dataToSend);
        setFormData({
            menu_id: '',
            role: '',
        }); // Reset
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg">
            <ModalHeader toggle={toggle}>Crear Permiso de Menú</ModalHeader>
            <ModalBody>
                <Form>
                    <FormGroup>
                        <Label for="menu_id">ID de Menú</Label>
                        <Input type="text" name="menu_id" id="menu_id" value={formData.menu_id} onChange={handleChange} />
                    </FormGroup>
                    <FormGroup>
                        <Label for="role">Rol</Label>
                        <Input type="text" name="role" id="role" value={formData.role} onChange={handleChange} />
                    </FormGroup>
                </Form>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={handleSave}>Guardar</Button>
                <Button color="secondary" onClick={toggle}>Cancelar</Button>
            </ModalFooter>
        </Modal>
    );
};

export default ModalCrearMenuPermission;